import { Trans, useTranslation } from 'next-i18next';

import { Image } from '../../../Image';

const GUARANTEE_IMAGE = '/images/framing-guarantee-thumbnail.png';

export type FramingGuaranteeVariant = 'price' | 'quality';

const FRAMING_GUARANTEE_VARIANTS: FramingGuaranteeVariant[] = [
  'price',
  'quality',
];

export const isFramingGuaranteeVariant = (
  value: string,
): value is FramingGuaranteeVariant =>
  (FRAMING_GUARANTEE_VARIANTS as string[]).includes(value);

export interface FramingGuaranteeProps {
  variant: FramingGuaranteeVariant;
}

/**
 * The framing quality guarantee card — placed right before the confirm
 * button, the point where a buyer is most likely to hesitate. Copy is
 * driven by the `framing-guarantee-copy` GrowthBook experiment.
 */
export const FramingGuarantee = ({ variant }: FramingGuaranteeProps) => {
  const { t } = useTranslation('checkout');

  return (
    <div className="flex items-stretch overflow-hidden rounded-sm border border-divider/20 bg-white">
      <div className="grid flex-1 gap-1 p-4">
        <p className="text-base font-bold leading-5 text-neutral-6">
          {t(`framing.guarantee.${variant}.title`)}
        </p>
        <p className="text-xs leading-4 text-neutral-6">
          <Trans
            components={{
              terms: (
                <a
                  className="hyperlink"
                  href="https://avantarte.com/support/terms-and-conditions"
                  rel="noopener noreferrer"
                  target="_blank"
                />
              ),
            }}
            i18nKey={`framing.guarantee.${variant}.description`}
            ns="checkout"
            t={t}
          />
        </p>
      </div>

      <span className="w-20 shrink-0 self-stretch overflow-hidden">
        <Image
          alt={t(`framing.guarantee.${variant}.title`)}
          className="h-full w-full object-cover"
          src={GUARANTEE_IMAGE}
          width={96}
        />
      </span>
    </div>
  );
};
